export const SET_SUBMITTED = 'SET_SUBMITTED';
export const SHOW_ADDRESS_FORM = 'SHOW_ADDRESS_FORM';
export const SET_ERRORS = 'SET_ERRORS';


// WEBPACK FOOTER //
// ./src/actionTypes/ui.js